import { createElement } from "react";

function IconUser({ className, ...props }) {
    return (
      createElement('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 256 256',
        fill: 'currentColor',
        ...props
      },
        createElement('path', {
          d: 'M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z',
        })
      )
    );
}
function IconEtani({ className, ...props }) {
    return (
        createElement('svg', {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 256 256',
            ...props,
            fill: '#fff',
            style: { backgroundColor: '#fff', borderRadius: '4px', width: '40px', height: '40px' }
        },
                createElement('g', { transform: 'translate(15.000000,240.000000) scale(0.100000,-0.100000)', stroke: 'none' },
                createElement('path', { d: 'M180 1095 l0 -965 950 0 950 0 0 115 0 115 -832 2 -833 3 -3 727 -2 728 832 2 833 3 3 118 3 117 -951 0 -950 0 0 -965z', fill: '#292a63' }),
                createElement('path', { d: 'M600 1095 l0 -545 740 0 740 0 0 115 0 115 -625 0 -625 0 0 310 0 310 623 2 622 3 3 118 3 117 -741 0 -740 0 0 -545z', fill: '#292a63' }),
                createElement('path', { d: 'M1030 1095 l0 -115 525 0 525 0 0 115 0 115 -525 0 -525 0 0 -115z', fill: '#292a63' }),
            )
        )
    );
}
function CloseTab({ className, ...props }) {
  return (
    createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 256 256',
      ...props,
      fill: 'none', // Set fill to none to make the background transparent
      style: {
        backgroundColor: 'transparent', // Set background color to transparent
        borderRadius: '4px',
        width: '35px',
        height: '35px',
      }
    },
      createElement('g', { stroke: '#fff' },
        createElement('path', { d: 'M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16ZM40 56h40v144H40Zm176 144H96V56h120v144Z', fill: '#fff' }),
      )
    )
  );
}

function IconTrash({ className, ...props }) {
  return (
    createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 256 256',
      fill: '#ff3e3e',
      style: { width: '45px', height: '20px' },
      ...props
    },
      createElement('path', { d: 'M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16ZM96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Z' }),
    )
  );
}
function IconLike({ className, ...props }) {
  return (
    createElement('svg', {
      viewBox: '0 0 24 24',
      fill: '#626262',
      xmlns: 'http://www.w3.org/2000/svg',
      style: { width: '25px', height: '15px' },
      ...props
    },
      createElement('g', null,
        createElement('path', { d: 'M2 9h3v12H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zm5.293-1.293l6.4-6.4a.5.5 0 0 1 .654-.047l.853.64a1.5 1.5 0 0 1 .553 1.57L14.6 8H21a2 2 0 0 1 2 2v2.104a2 2 0 0 1-.15.762l-3.095 7.515a1 1 0 0 1-.925.619H8a1 1 0 0 1-1-1V8.414a1 1 0 0 1 .293-.707z' }),
      )
    )
  );
}

function IconDislike({ className, ...props }) {
  return (
    createElement('svg', {
      viewBox: '0 0 24 24',
      fill: '#626262',
      xmlns: 'http://www.w3.org/2000/svg',
      style: { width: '25px', height: '15px' },
      ...props
    },
      createElement('g', null,
        createElement('path', { d: 'M22 15h-3V3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm-5.293 1.293l-6.4 6.4a.5.5 0 0 1-.654.047L8.8 22.1a1.5 1.5 0 0 1-.553-1.57L9.4 16H3a2 2 0 0 1-2-2v-2.104a2 2 0 0 1 .15-.762L4.246 3.62A1 1 0 0 1 5.17 3H16a1 1 0 0 1 1 1v11.586a1 1 0 0 1-.293.707z' }),
      )
    )
  );
}
function Shield({ className, ...props }) {
  return (
    createElement('svg', {
      viewBox: '0 0 24 24',
      fill: '#fff',
      xmlns: 'http://www.w3.org/2000/svg',
      style: { width: '25px', height: '15px', stroke: '#333' },
      ...props
    },
      createElement('g', null,
        createElement('path', { d: 'M19,14.7368421 C19,17.122807 16.6666667,19.2105263 12,21 C7.33333333,19.2105263 5,17.122807 5,14.7368421 C5,12.3508772 5,9.36842105 5,5.78947368 C8.13611482,4.59649123 10.4694481,4 12,4 C13.5305519,4 15.8638852,4.59649123 19,5.78947368 C19,9.36842105 19,12.3508772 19,14.7368421 Z' }),
      )
    )
  );
}

function IconSort({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style={{ width: '20px', height: '20px' }} {...props}>
      <path d="M4 8H13" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6 13H13" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 18H13" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17 20V4L20 8" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconGrid({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#525f7f" width="20px" height="20px" viewBox="0 0 1920 1920">
        <path d="M1800 1320v420c0 33-27 60-60 60h-420v-480h480Zm-600 0v480H720v-480h480Zm-600 0v480H180c-33 0-60-27-60-60v-420h480Zm1200-600v480h-480V720h480Zm-600 0v480H720V720h480Zm-600 0v480H120V720h480Zm1140-600c33 0 60 27 60 60v420h-480V120h420Zm-540 0v480H720V120h480Zm-600 0v480H120V180c0-33 27-60 60-60h420ZM1740 0H180C80.76 0 0 80.76 0 180v1560c0 99.24 80.76 180 180 180h1560c99.24 0 180-80.76 180-180V180c0-99.24-80.76-180-180-180Z" fillRule="evenodd"/>
    </svg>
  );
}
function IconPie({ className, ...props }) {
  return (
  <svg width="25px" height="25px" viewBox="3 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.75 3.75H12V12H20.25V11.25C20.25 7.10786 16.8921 3.75 12.75 3.75ZM13.5 10.5V5.29642C16.214 5.63486 18.3651 7.78596 18.7036 10.5H13.5ZM4.5 13.5C4.5 10.4403 6.79027 7.91549 9.75 7.54642V14.25H16.4536C16.0845 17.2097 13.5597 19.5 10.5 19.5C7.18629 19.5 4.5 16.8137 4.5 13.5ZM10.5 6C6.35786 6 3 9.35786 3 13.5C3 17.6421 6.35786 21 10.5 21C14.6421 21 18 17.6421 18 13.5V12.75H11.25V6H10.5Z" fill="#525f7f"/>
  </svg>
  );
}
function IconBar({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#525f7f" width="20px" height="20px" viewBox="-0.5 0 32 32" preserveAspectRatio="xMidYMid">
        <path d="M30.000,32.000 L23.000,32.000 C22.447,32.000 22.000,31.552 22.000,31.000 L22.000,1.000 C22.000,0.448 22.447,-0.000 23.000,-0.000 L30.000,-0.000 C30.553,-0.000 31.000,0.448 31.000,1.000 L31.000,31.000 C31.000,31.552 30.553,32.000 30.000,32.000 ZM29.000,2.000 L24.000,2.000 L24.000,30.000 L29.000,30.000 L29.000,2.000 ZM19.000,32.000 L12.000,32.000 C11.448,32.000 11.000,31.552 11.000,31.000 L11.000,17.000 C11.000,16.448 11.448,16.000 12.000,16.000 L19.000,16.000 C19.553,16.000 20.000,16.448 20.000,17.000 L20.000,31.000 C20.000,31.552 19.553,32.000 19.000,32.000 ZM18.000,18.000 L13.000,18.000 L13.000,30.000 L18.000,30.000 L18.000,18.000 ZM8.000,32.000 L1.000,32.000 C0.448,32.000 0.000,31.552 0.000,31.000 L0.000,11.000 C0.000,10.448 0.448,10.000 1.000,10.000 L8.000,10.000 C8.552,10.000 9.000,10.448 9.000,11.000 L9.000,31.000 C9.000,31.552 8.552,32.000 8.000,32.000 ZM7.000,12.000 L2.000,12.000 L2.000,30.000 L7.000,30.000 L7.000,12.000 Z"/>
    </svg>
  );
}
function IconLine({ className, ...props }) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
    <path xmlns="http://www.w3.org/2000/svg" d="M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M20 8L16.0811 12.1827C15.9326 12.3412 15.8584 12.4204 15.7688 12.4614C15.6897 12.4976 15.6026 12.5125 15.516 12.5047C15.4179 12.4958 15.3215 12.4458 15.1287 12.3457L11.8713 10.6543C11.6785 10.5542 11.5821 10.5042 11.484 10.4953C11.3974 10.4875 11.3103 10.5024 11.2312 10.5386C11.1416 10.5796 11.0674 10.6588 10.9189 10.8173L7 15" stroke="#525f7f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  );
}
function IconCard({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="2 2 17 17">
      <g fill="none" fillRule="evenodd" stroke="#525f7f" strokeLinecap="round" strokeLinejoin="round" transform="translate(2 3)">
        <path d="m5.5.5h6c1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2h-6c-1.1045695 0-2-.8954305-2-2v-10c0-1.1045695.8954305-2 2-2zm8 2.5h1c1.1045695 0 2 .8954305 2 2v5c0 1.1045695-.8954305 2-2 2h-1z"/>
        <path d="m.5 3h1c1.1045695 0 2 .8954305 2 2v5c0 1.1045695-.8954305 2-2 2h-1z" transform="matrix(-1 0 0 1 4 0)"/>
      </g>
    </svg>
  );
}
function IconClose({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
      <path d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 
      7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 
      8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 
      14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 
      13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 
      14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z" fill="#f55b5b"/>
      <path fillRule="evenodd" clipRule="evenodd" 
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 
        23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 
        16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z" fill="#f55b5b"/>
    </svg>
  );
}
function IconManage ({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="20px" viewBox="0 0 30 24" fill="none">
      <path  fill="#000b8a" d="M7,8.05V5.5C7,5.224,6.776,5,6.5,5S6,5.224,6,5.5v2.55C4.306,8.295,3,9.738,3,11.5s1.306,3.205,3,3.45  V26.5C6,26.776,6.224,27,6.5,27S7,26.776,7,26.5V14.95c1.694-0.245,3-1.688,3-3.45S8.694,8.295,7,8.05z M6.5,14  C5.122,14,4,12.878,4,11.5C4,10.121,5.122,9,6.5,9S9,10.121,9,11.5C9,12.878,7.878,14,6.5,14z M16,17.05V5.5  C16,5.224,15.776,5,15.5,5S15,5.224,15,5.5v11.55c-1.694,0.245-3,1.688-3,3.45s1.306,3.205,3,3.45v2.55c0,0.276,0.224,0.5,0.5,0.5  s0.5-0.224,0.5-0.5v-2.55c1.694-0.245,3-1.688,3-3.45S17.694,17.295,16,17.05z M15.5,23c-1.378,0-2.5-1.122-2.5-2.5  c0-1.379,1.122-2.5,2.5-2.5s2.5,1.121,2.5,2.5C18,21.878,16.878,23,15.5,23z M28,14.5c0-1.762-1.306-3.205-3-3.45V5.5  C25,5.224,24.776,5,24.5,5S24,5.224,24,5.5v5.55c-1.694,0.245-3,1.688-3,3.45s1.306,3.205,3,3.45v8.55c0,0.276,0.224,0.5,0.5,0.5  s0.5-0.224,0.5-0.5v-8.55C26.694,17.705,28,16.262,28,14.5z M24.5,17c-1.378,0-2.5-1.122-2.5-2.5c0-1.379,1.122-2.5,2.5-2.5  s2.5,1.121,2.5,2.5C27,15.878,25.878,17,24.5,17z"/>
    </svg>
  )
}
function IconEdit ({ className, ...props  }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none" id="create-note">
      <path  fill={props.stroke}
        d="M20.71,3.29a2.91,2.91,0,0,0-2.2-.84,3.25,3.25,0,0,0-2.17,1L9.46,10.29s0,0,0,0a.62.62,0,0,0-.11.17,1,1,0,0,0-.1.18l0,0L8,14.72A1,1,0,0,0,9,16a.9.9,0,0,0,.28,0l4-1.17,0,0,.18-.1a.62.62,0,0,0,.17-.11l0,0,6.87-6.88a3.25,3.25,0,0,0,1-2.17A2.91,2.91,0,0,0,20.71,3.29Z"/>
      <path  fill={props.stroke}
        d="M20,22H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2h8a1,1,0,0,1,0,2H4V20H20V12a1,1,0,0,1,2,0v8A2,2,0,0,1,20,22Z"/>
      </svg>
  )
}
function IconCreate ({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
      <rect x="0" fill="none" width="24" height="24"/>
      <path fill="#000b8a" d="M21 14v5c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h5v2H5v14h14v-5h2z"/>
      <path fill="#000b8a" d="M21 7h-4V3h-2v4h-4v2h4v4h2V9h4"/>
    </svg>
  )
}
function IconDashboard ({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.918 10.0005H7.082C6.66587 9.99708 6.26541 10.1591 5.96873 10.4509C5.67204 10.7427 5.50343 11.1404 5.5 11.5565V17.4455C5.5077 18.3117 6.21584 19.0078 7.082 19.0005H9.918C10.3341 19.004 10.7346 18.842 11.0313 18.5502C11.328 18.2584 11.4966 17.8607 11.5 17.4445V11.5565C11.4966 11.1404 11.328 10.7427 11.0313 10.4509C10.7346 10.1591 10.3341 9.99708 9.918 10.0005Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.918 4.0006H7.082C6.23326 3.97706 5.52559 4.64492 5.5 5.4936V6.5076C5.52559 7.35629 6.23326 8.02415 7.082 8.0006H9.918C10.7667 8.02415 11.4744 7.35629 11.5 6.5076V5.4936C11.4744 4.64492 10.7667 3.97706 9.918 4.0006Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.082 13.0007H17.917C18.3333 13.0044 18.734 12.8425 19.0309 12.5507C19.3278 12.2588 19.4966 11.861 19.5 11.4447V5.55666C19.4966 5.14054 19.328 4.74282 19.0313 4.45101C18.7346 4.1592 18.3341 3.9972 17.918 4.00066H15.082C14.6659 3.9972 14.2654 4.1592 13.9687 4.45101C13.672 4.74282 13.5034 5.14054 13.5 5.55666V11.4447C13.5034 11.8608 13.672 12.2585 13.9687 12.5503C14.2654 12.8421 14.6659 13.0041 15.082 13.0007Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.082 19.0006H17.917C18.7661 19.0247 19.4744 18.3567 19.5 17.5076V16.4936C19.4744 15.6449 18.7667 14.9771 17.918 15.0006H15.082C14.2333 14.9771 13.5256 15.6449 13.5 16.4936V17.5066C13.525 18.3557 14.2329 19.0241 15.082 19.0006Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
function IconAnalyzer ({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
      <g stroke={props.stroke || "#bbbbb"} strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M20,4 L20,20 L4,20 L4,4 L20,4 Z M10.734,8 L9.176,8 L6.215,16 L7.624,16 L8.182,14.436 L11.723,14.436 L12.270,16 L13.760,16 L10.734,8 Z M16.256,8 L14.856,8 L14.856,16 L16.256,16 L16.256,8 Z M9.944,9.342 L11.338,13.333 L8.571,13.333 L9.944,9.342 Z" fill={props.stroke || "#bbbbb"}/>
      </g>
    </svg>
  )
}
function IconBar2 ({ className, ...props }) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="20px" viewBox="0 0 24 24" fill="none">
    <path d="M20 13.75C20 13.3358 19.6642 13 19.25 13H16.25C15.8358 13 15.5 13.3358 15.5 13.75V20.5H14V4.25C14 3.52169 13.9984 3.05091 13.9518 2.70403C13.908 2.37872 13.8374 2.27676 13.7803 2.21967C13.7232 2.16258 13.6213 2.09197 13.296 2.04823C12.9491 2.00159 12.4783 2 11.75 2C11.0217 2 10.5509 2.00159 10.204 2.04823C9.87872 2.09197 9.77676 2.16258 9.71967 2.21967C9.66258 2.27676 9.59196 2.37872 9.54823 2.70403C9.50159 3.05091 9.5 3.52169 9.5 4.25V20.5H8V8.75C8 8.33579 7.66421 8 7.25 8H4.25C3.83579 8 3.5 8.33579 3.5 8.75V20.5H2H1.75C1.33579 20.5 1 20.8358 1 21.25C1 21.6642 1.33579 22 1.75 22H21.75C22.1642 22 22.5 21.6642 22.5 21.25C22.5 20.8358 22.1642 20.5 21.75 20.5H21.5H20V13.75Z" fill={props.stroke}/>
  </svg>
  )
}
function IconMenu ({ className, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="-0.5 0 25 25" fill="none">
      <path d="M19 3.32001H16C14.8954 3.32001 14 4.21544 14 5.32001V8.32001C14 9.42458 14.8954 10.32 16 10.32H19C20.1046 10.32 21 9.42458 21 8.32001V5.32001C21 4.21544 20.1046 3.32001 19 3.32001Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 3.32001H5C3.89543 3.32001 3 4.21544 3 5.32001V8.32001C3 9.42458 3.89543 10.32 5 10.32H8C9.10457 10.32 10 9.42458 10 8.32001V5.32001C10 4.21544 9.10457 3.32001 8 3.32001Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19 14.32H16C14.8954 14.32 14 15.2154 14 16.32V19.32C14 20.4246 14.8954 21.32 16 21.32H19C20.1046 21.32 21 20.4246 21 19.32V16.32C21 15.2154 20.1046 14.32 19 14.32Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 14.32H5C3.89543 14.32 3 15.2154 3 16.32V19.32C3 20.4246 3.89543 21.32 5 21.32H8C9.10457 21.32 10 20.4246 10 19.32V16.32C10 15.2154 9.10457 14.32 8 14.32Z" stroke={props.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

function IconVibeCfo({ className, ...props }) {
  return (
    createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 501 498',
      ...props,
      fill: '#fff',
      style: { backgroundColor: '#fff', borderRadius: '4px', width: '40px', height: '40px' }
    },
      createElement('g', { transform: 'translate(0.000000,498.000000) scale(0.100000,-0.100000)', stroke: '#8C52FF' },
        createElement('path', {
          d: 'M2114 4603 c17 -353 79 -630 210 -935 25 -59 46 -113 46 -120 0 -8 16 -40 35 -72 19 -32 35 -60 35 -61 0 -15 127 -210 161 -248 15 -16 33 -41 40 -55 41 -84 354 -413 450 -476 30 -19 79 -56 111 -83 31 -26 90 -68 132 -93 41 -25 76 -48 76 -52 0 -10 -95 -58 -115 -58 -21 0 -305 -192 -354 -240 -23 -22 -45 -40 -50 -40 -12 0 -241 -240 -241 -252 0 -6 -8 -18 -18 -27 -10 -9 -44 -53 -76 -98 -32 -46 -61 -83 -64 -83 -4 0 -25 28 -47 62 -121 189 -315 387 -519 530 -44 31 -92 65 -106 76 -31 23 -104 61 -195 101 -38 17 -71 34 -72 38 -1 5 24 27 57 51 121 88 275 237 379 366 31 39 64 80 74 90 9 11 17 25 17 31 0 6 13 29 28 51 16 21 45 69 64 105 l36 66 -90 83 c-104 97 -227 200 -236 200 -4 0 -40 32 -81 70 -41 39 -86 79 -101 90 l-27 19 -59 -67 c-32 -37 -63 -73 -69 -80 -5 -7 -18 -21 -28 -30 -11 -9 -38 -34 -60 -55 -81 -74 -243 -202 -282 -223 -22 -12 -85 -48 -140 -80 -55 -32 -136 -73 -180 -92 -182 -77 -240 -94 -443 -127 l-172 -29 2 -405 3 -406 75 -11 c87 -13 220 -40 270 -56 113 -34 352 -131 380 -154 8 -7 33 -19 56 -26 41 -15 198 -112 231 -145 11 -10 52 -43 93 -73 154 -115 382 -374 459 -522 15 -29 47 -87 70 -130 107 -195 193 -445 209 -608 l7 -65 350 0 350 0 8 54 c19 133 126 471 184 581 174 331 400 592 688 791 157 110 170 118 183 118 7 1 65 26 130 57 190 91 356 141 620 184 l72 12 0 404 0 404 -27 0 c-40 0 -308 46 -373 63 -146 40 -404 157 -520 237 -14 9 -32 19 -40 22 -28 10 -195 141 -265 207 -148 141 -191 189 -270 301 -149 212 -240 376 -270 485 -8 28 -23 77 -35 109 -28 77 -77 285 -85 361 -4 33 -9 68 -11 78 -5 16 -30 17 -341 17 l-335 0 6 -137z',
          fill: '#8C52FF'
        })
      )
    )
  );
}
function IconPDF ({ className, ...props }) {    
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="40px" viewBox="0 0 475 530" fill={props.stroke}>
      <g>
        <path stroke={props.stroke} d="M378.413,0H208.297h-13.182L185.8,9.314L57.02,138.102l-9.314,9.314v13.176v265.514   c0,47.36,38.528,85.895,85.896,85.895h244.811c47.353,0,85.881-38.535,85.881-85.895V85.896C464.294,38.528,425.766,0,378.413,0z    M432.497,426.105c0,29.877-24.214,54.091-54.084,54.091H133.602c-29.884,0-54.098-24.214-54.098-54.091V160.591h83.716   c24.885,0,45.077-20.178,45.077-45.07V31.804h170.116c29.87,0,54.084,24.214,54.084,54.092V426.105z"/>
        <path stroke={props.stroke} d="M171.947,252.785h-28.529c-5.432,0-8.686,3.533-8.686,8.825v73.754c0,6.388,4.204,10.599,10.041,10.599   c5.711,0,9.914-4.21,9.914-10.599v-22.406c0-0.545,0.279-0.817,0.824-0.817h16.436c20.095,0,32.188-12.226,32.188-29.612   C204.136,264.871,192.182,252.785,171.947,252.785z M170.719,294.888h-15.208c-0.545,0-0.824-0.272-0.824-0.81v-23.23   c0-0.545,0.279-0.816,0.824-0.816h15.208c8.42,0,13.447,5.027,13.447,12.498C184.167,290,179.139,294.888,170.719,294.888z"/>
        <path stroke={props.stroke} d="M250.191,252.785h-21.868c-5.432,0-8.686,3.533-8.686,8.825v74.843c0,5.3,3.253,8.693,8.686,8.693h21.868   c19.69,0,31.923-6.249,36.81-21.324c1.76-5.3,2.723-11.681,2.723-24.857c0-13.175-0.964-19.557-2.723-24.856   C282.113,259.034,269.881,252.785,250.191,252.785z M267.856,316.896c-2.318,7.331-8.965,10.459-18.21,10.459h-9.23   c-0.545,0-0.824-0.272-0.824-0.816v-55.146c0-0.545,0.279-0.817,0.824-0.817h9.23c9.245,0,15.892,3.128,18.21,10.46   c0.95,3.128,1.62,8.56,1.62,17.93C269.476,308.336,268.805,313.768,267.856,316.896z"/>
        <path stroke={props.stroke} d="M361.167,252.785h-44.812c-5.432,0-8.7,3.533-8.7,8.825v73.754c0,6.388,4.218,10.599,10.055,10.599   c5.697,0,9.914-4.21,9.914-10.599v-26.351c0-0.538,0.265-0.81,0.81-0.81h26.086c5.837,0,9.23-3.532,9.23-8.56   c0-5.028-3.393-8.553-9.23-8.553h-26.086c-0.545,0-0.81-0.272-0.81-0.817v-19.425c0-0.545,0.265-0.816,0.81-0.816h32.733   c5.572,0,9.245-3.666,9.245-8.553C370.411,256.45,366.738,252.785,361.167,252.785z"/>
      </g>
    </svg>
  )
}
function IconFolder ({ className, ...props }) {    
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={props.stroke}>
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier"> 
        <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        </path>
      </g>
    </svg>
  )
}
function IconAskEVA ({ className, ...props }) {    
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 30 30" fill={props.stroke}>
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path class="bentblocks_een" d="M26,4H6C4.9,4,4,4.9,4,6v16c0,1.1,0.9,2,2,2h6l4,4l4-4h6c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,22h-6.828L16,25.172L12.828,22H6V6h20V22z M12,16h-2v-2h2V16z M17,16h-2v-2h2V16z M22,16h-2v-2h2V16z">
          </path>
      </g>
      </svg>
  )
}
function IconBuilder ({ className, ...props }) {    
  return (
<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.16923 2.00234C8.11301 2.00078 8.0566 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 7.9434 13.9992 7.88699 13.9977 7.83077L15.7642 6.06422C15.9182 6.68407 16 7.33249 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C8.66751 0 9.31593 0.0817526 9.93578 0.235791L8.16923 2.00234Z" fill="#000000"></path> <path d="M4 7.99996C4 6.13612 5.27477 4.57002 7 4.12598V6.26752C6.4022 6.61333 6 7.25968 6 7.99996C6 9.10453 6.89543 9.99996 8 9.99996C8.74028 9.99996 9.38663 9.59776 9.73244 8.99996H11.874C11.4299 10.7252 9.86384 12 8 12C5.79086 12 4 10.2091 4 7.99996Z" fill="#000000"></path> <path d="M14 2L13 0L10 3V4.58579L7.79289 6.79289L9.20711 8.20711L11.4142 6H13L16 3L14 2Z" fill="#000000"></path> </g></svg>
  )
}
export {
    IconAnalyzer,
    IconUser,
    IconEtani,
    CloseTab,
    IconTrash,
    IconLike,
    IconDislike,
    IconSort,
    Shield,
    IconGrid,
    IconPie,
    IconBar,
    IconLine,
    IconCard,
    IconClose,
    IconManage,
    IconEdit,
    IconCreate,
    IconDashboard,
    IconBar2,
    IconMenu,
    IconVibeCfo,
    IconPDF,
    IconFolder,
    IconAskEVA,
    IconBuilder
}